import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';

import { ContactUsData, reportsHttp } from '@network';
import { InitialCard } from '@components';
import { querySerialize } from '@utils';
import { LinkBlockBtn } from '@pages/dashboard/LinkBlockBtn';
import { Tooltip } from 'antd';

interface Props {
  range: string;
  setLoader: (num: number, value: boolean) => void;
}

export const ContactUsReport = ({ range, setLoader }: Props) => {
  const [numbers, setNumbers] = useState<ContactUsData>();
  const cls = useStyles();

  const loadNumbers = async () => {
    setLoader(12, true);
    try {
      const nextNumbers = await reportsHttp.contactUsReport({ range });
      setNumbers(nextNumbers);
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(12, false);
    }
  };

  useEffect(() => void loadNumbers(), [range]);

  const openedLink = '/feedback/contact?' + querySerialize({
    filter: JSON.stringify({
      status: 'opened',
      createdAt: range || undefined,
    }),
  });
  const processingLink = '/feedback/contact?' + querySerialize({
    filter: JSON.stringify({
      status: 'processing',
      createdAt: range || undefined,
    }),
  });

  const blocks: {title: string, link: string, total: number, className: string}[] = [
    {
      title: 'New',
      total: numbers?.opened || 0,
      link: openedLink,
      className: cls.btnOpened,
    },
    {
      title: 'Processing',
      total: numbers?.processing || 0,
      link: processingLink,
      className: cls.btnProcessing,
    },
  ];

  return (
    <InitialCard
      center="Contact us entries"
      extraPadding
      fullHeight
      left={<div/>}
      right={
        <Tooltip title="Not affected by time filter" placement="left" color="#042E6B">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#F38336">
            <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 27-3 53t-10 51q-14-16-32.5-27T794-418q3-15 4.5-30.5T800-480q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93q51 0 97.5-15t85.5-42q12 17 29.5 30t37.5 20q-51 41-114.5 64T480-80Zm290-160q-21 0-35.5-14.5T720-290q0-21 14.5-35.5T770-340q21 0 35.5 14.5T820-290q0 21-14.5 35.5T770-240Zm-158-52L440-464v-216h80v184l148 148-56 56Z"/>
          </svg>
        </Tooltip>
      }
    >
      {blocks.map(block => (
        <div key={block.title} className={cls.block}>
          <LinkBlockBtn key={block.title} whiteColor {...block} />
        </div>
      ))}
    </InitialCard>
  );
};

const useStyles = makeStyles({
  block: {
    marginTop: 20,
  },
  btnOpened: {
    borderRadius: 8,
    border: '1px solid #042E6B',
    background: '#1677FF',
    '&:hover': {
      background: '#125dc7',
    },
  },
  btnProcessing: {
    borderRadius: 8,
    border: '1px solid #042E6B',
    background: '#FAAD14',
    '&:hover': {
      background: '#be8410',
    },
  },
});
